<template>
  <v-footer  padless class="mt-5">
    <v-card class="flex" flat tile>

      <v-card-text class="py-2 text-center">
        <!-- Contenedor para centrar verticalmente si es necesario -->
          <img src="@/assets/logo.png" alt="Logo MasterFit" width="120" class="mb-2"><br>
          <span class="black--text text-subtitle-1">{{ new Date().getFullYear() }}</span>
      </v-card-text>
    </v-card>
  </v-footer>
</template>
<script>
export default {
  name: "PieComponent",
};
</script>


// WEBPACK FOOTER //
// src/components/Dialogos/PieComponent.vue